import React, { useMemo } from "react";
// import { useAppData } from "@danishagro/shared/src/contexts/appData.context";
// import { DA_MiniCartPopUpB2cMobile } from "@danishagro/b2c/src/components/organisms/SiteHeader/MiniCart/MiniCartMobile/MiniCartMobile.component";
import { useCart } from "../../../../../contexts/cart/cart.context";
import { useBasket } from "../../../../../contexts/basket/basket.context";
import { useSiteHeader } from "../../../../../contexts/siteHeader.context";
import { DA_MiniCartPopUp } from "../../MiniCart/MiniCart.component";
import { DA_MiniCartPopUpB2C } from "../../MiniCartB2C/MiniCart.component";
import { useBottomSheet } from "../../../../../contexts/bottomSheet/bottomSheet.context";
import { useTranslations } from "../../../../../contexts/translations/translations.context";

export const useCartButton = () => {
    const isHattingAgroB2B = globalThis.b2bsitevariant === "hatting-agro-b2b";

    // Use basket context for Hatting Agro B2B, cart context for others
    const cartContext = useCart();
    const basketContext = useBasket();

    const { orderLines, isLoadingCart } = isHattingAgroB2B
        ? {
              orderLines: basketContext.orderLines,
              isLoadingCart: basketContext.isLoadingBasket,
          }
        : cartContext;

    const { showMiniCart, closeMobileNav, showMobileNav } = useSiteHeader();
    const { getDictionaryString } = useTranslations();
    // const { currentSite } = useAppData();

    const { presentBottomSheet, dismissBottomSheet, activeBottomSheet } = useBottomSheet();

    const onCartButtonClicked = () => {
        const id = "cart";

        if (activeBottomSheet !== id) {
            // TODO: Disabled B2C for now due to reference issue. Clean up in B2C folder.
            // presentBottomSheet(
            //     currentSite === "B2C" ? <DA_MiniCartPopUpB2cMobile /> : <DA_MiniCartPopUp />,
            //     currentSite === "B2C"
            //         ? {
            //               id: id,
            //               headerTitle: getDictionaryString("header.miniBasket.title", {
            //                   uppercaseFirst: true,
            //               }),
            //           }
            //         : {
            //               id: id,
            //               headerTitle: getDictionaryString("miniCartTitle", {
            //                   uppercaseFirst: true,
            //               }),
            //           }
            // );
            presentBottomSheet(isHattingAgroB2B ? <DA_MiniCartPopUpB2C /> : <DA_MiniCartPopUp />, {
                id: id,
                headerTitle: getDictionaryString("miniCartTitle", {
                    uppercaseFirst: true,
                }),
            });
            // Close mobileNav after bottomSheet has opened
            if (showMobileNav) {
                setTimeout(() => {
                    closeMobileNav();
                }, 500);
            }
        } else {
            dismissBottomSheet();
        }
    };

    // Mappers

    const totalQuantity: number = useMemo(() => {
        if (!orderLines || orderLines.length === 0) {
            return 0;
        }

        let total = 0;
        for (const line of orderLines) {
            total += line.quantity || 0;
        }
        return total;
    }, [orderLines]);

    return {
        showCart: true,
        onCartButtonClicked,
        cartBadge: totalQuantity,
        isCartMenuActive: showMiniCart,
        isLoadingCart,
    };
};
